import React, { Component } from "react";
import FieldValidationContext from "../../../Context/FieldValidationContext";
import PropTypes from "prop-types";

export default class FieldValidationProvider extends Component {

    static propTypes = {
        validity: PropTypes.object.isRequired
    }

    render() {
        const { validity, children } = this.props;
        return (
            <FieldValidationContext.Provider value={ validity }>
                {children}
            </FieldValidationContext.Provider>
        );
    }

}